import React, { useState } from "react";
import Image from "next/image";
import { Divider } from "antd";
import { GoSearch } from "react-icons/go";

//components
import ShortlistCampaignCard from "../ShortlistCampaignCard";
import Button from "@/shared/Button";
import notification from "@/components/notifications";
import Input from "@/shared/Input/Input";
import { getSuccessMessage } from "../SaveToShortlistForm/SaveToShortListForm";

// interfaces
import { ISpaceFull } from "@/types/Space";
import { ICampaign } from "@/types/api/Campaign";

// assets
import UndrawEventsImg from "@/assets/images/undraw_events.svg";
import styles from "@/assets/styles/containers/shortlist-form.module.scss";


interface SaveToExistingFormProps {
  space: ISpaceFull;
  campaigns?: Array<ICampaign>; // Replace with the actual type
  toggleForm: () => void;
  onCampaignToggle: (e: boolean) => void;
}


const SaveToExistingForm = ({ space, campaigns = [], toggleForm, onCampaignToggle }: SaveToExistingFormProps) => {
  const [searchValue, setSearchValue] = useState("");

  const searchedCampaigns = campaigns
    .filter(el => el?.name?.toLowerCase().includes(searchValue.toLowerCase()));

  // renders
  const renderEmpty = () => (
    <div className={styles["locl-shortlist-form_search_empty"]}>
      <Image
        src={UndrawEventsImg}
        width={230}
        height={176}
        className={styles["locl-shortlist-form_search_empty__img"]}
        alt="undraw events img"
      />
      <div className={styles["locl-shortlist-form_search_empty__info"]}>
        <div className={styles["locl-shortlist-form_search_empty__title"]}>
          You don’t have campaigns yet
        </div>
        <div className={styles["locl-shortlist-form_search_empty__subtitle"]}>
          Let’s create your first campaign together!
        </div>
      </div>
    </div>
  );

  const renderList = () => (<>
    <Input
      onChange={e => setSearchValue(e.target.value)}
      placeholder="Search for campaigns."
      data-testid="locl-shortlist-form-input-search"
      wrapperClassName={styles["locl-shortlist-form_search_input"]}
      addonBefore={<GoSearch/>}
    />
    <div className={styles["locl-shortlist-form_search_card_container"]}>
      {searchedCampaigns.map((campaign, i) => (
        <ShortlistCampaignCard
          wrapperClass={styles["locl-shortlist-form_search_card"]}
          key={campaign.name + i}
          campaign={campaign}
          space={space}
          onCampaignToggle={e => {
            if (!e) {
              notification({
                placement: "topRight",
                duration: 30,
                actionText: "View campaign",
                actionProps: { href: `/campaign/${campaign.id}/planner` },
                message: getSuccessMessage(space.name, campaign),
                type: "success",
              });
            }
            onCampaignToggle(e);
          }}
        />
      ))}
    </div>
    <Divider className={styles["locl-shortlist-form_divider"]}>
      <p className={styles["locl-shortlist-form_divider_text"]}>
        Are you working on something else?
      </p>
    </Divider>
  </>)

  return (<>
    {
      !!campaigns.length &&
        <p className={styles["locl-shortlist-form__title"]}>
          Save to a new or existing campaign
        </p>
    }
    <div className="locl-shortlist-form_search">
      {
        campaigns.length
          ? renderList()
          : renderEmpty()
      }
      <Button
        onClick={toggleForm}
        data-testid="locl-shortlist-form-create-campaign-btn"
        fullWidth
      >
        Create new campaign
      </Button>
    </div>
  </>);
};

export default SaveToExistingForm;
